{
  "version": 1,
  "asset_id": "2c33dec3-a893-4a18-8567-4b7fc29c3fe4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2c33dec3-a893-4a18-8567-4b7fc29c3fe4/hiatal-recurrent-redo-2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2c33dec3-a893-4a18-8567-4b7fc29c3fe4/hiatal-recurrent-redo-2-1200.webp",
  "original_filename": "hiatal-recurrent-redo-2-1200.webp",
  "size": 144722,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:26Z"
}
